import { TopRankTable } from '../TopRankTable'
import { withTopBookTable } from './withTopBookTable'

const ConnectedTopBookTable = withTopBookTable(TopRankTable)

export { ConnectedTopBookTable as TopBookTable }
